import { call, put, takeEvery } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "./customUrlsPutActions";

function* customUrlsPut(action) {
  try {
    let { id } = action.payload;
    let response = yield call(
      requestWithSubTenantIfNeeded,
      "put",
      `customUrls/${id}`,
      { json: action.payload }
    );

    yield put(actions.requestSuccess(action.payload, response.data));

    if (action.resolve) {
      yield call(action.resolve, response.data);
    }
  } catch (error) {
    yield put(actions.requestFailure(action.payload, error));

    if (action.reject) {
      yield call(action.reject, error);
    }
  }
}

function* saga() {
  yield takeEvery(actions.CUSTOMURLS_PUT_REQUEST, customUrlsPut);
}

export default saga;
